_ = require('underscore');
module.exports = {
    "modalCarouselTemplate": function(obj) {
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
__p += '\n    <div class="modal-carousel2">\n        <div class="modal-carousel-body">\n            <div class="modal-carousel-previous">\n                ' +
((__t = ( obj.arrowLeftIcon )) == null ? '' : __t) +
'\n            </div>\n            <div class="modal-carousel-image">\n                <img class="modal-carousel-small-image" />\n            </div>\n            <div class="modal-carousel-next">\n                ' +
((__t = ( obj.arrowRightIcon )) == null ? '' : __t) +
'\n            </div>\n        </div>\n        <div class="modal-carousel-footer">\n            <div class="modal-carousel-social social-share-nav use-icons is-round is-reverse item-hero-actions-social"></div>\n            <div class="modal-carousel-bin"></div>\n            <div class="modal-carousel-actions">\n                ';
 if (obj.purchasable) { ;
__p += '\n                    <a href="' +
((__t = ( obj.checkoutRoute )) == null ? '' : __t) +
'" class="button-primary button-medium modal-carousel-purchase">purchase</a>\n                ';
 } ;
__p += '\n            </div>\n        </div>\n    </div>\n';
return __p
}
};


//////////////////
// WEBPACK FOOTER
// ./assets/js/templates/pdp/modalCarousel.html
// module id = 1897
// module chunks = 4 7